import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: {
        translation: {
          "newCategory": "Yeni Kategori Ekle",
          "categoryName": "Kategori Adı",
          "description": "Açıklama",
          "icon": "İkon",
          "categoryImage": "Kategori Görseli",
          "save": "Kaydet",
          "cancel": "İptal",
          "saving": "Kaydediliyor...",
          "error": "Hata",
          "success": "Başarılı",
          "pleaseSelectImage": "Lütfen bir görsel seçin.",
          "categoryCreated": "Kategori başarıyla oluşturuldu.",
          "categoryError": "Kategori kaydedilemedi. Lütfen tekrar deneyiniz.",
          "noCategories": "Henüz kategori bulunmuyor.",
          "expertiseAreas": "Uzmanlık Alanlarımız",
          "newExpertiseArea": "Yeni Uzmanlık Alanı",
          "editExpertiseArea": "Uzmanlık Alanı Düzenle",
          "expertiseTitle": "Başlık",
          "expertiseDescription": "Açıklama",
          "expertiseIcon": "İkon",
          "expertiseIconPlaceholder": "İkon ara...",
          "expertiseTitlePlaceholder": "Uzmanlık alanı başlığı",
          "expertiseDescriptionPlaceholder": "Uzmanlık alanı açıklaması",
          "expertiseSelected": "Seçili:",
          "expertiseNoResults": "Sonuç yok",
          "expertiseLoading": "Yükleniyor...",
          "expertiseSaving": "Kaydediliyor...",
          "expertiseSave": "Kaydet",
          "expertiseCancel": "İptal",
          "expertiseSuccess": "Başarılı",
          "expertiseError": "Hata",
          "expertiseCreated": "Uzmanlık alanı başarıyla eklendi.",
          "expertiseUpdated": "Uzmanlık alanı başarıyla güncellendi.",
          "expertiseDeleted": "Uzmanlık alanı başarıyla silindi.",
          "expertiseCreateError": "Uzmanlık alanı eklenirken bir hata oluştu.",
          "expertiseUpdateError": "Uzmanlık alanı güncellenirken bir hata oluştu.",
          "expertiseDeleteError": "Uzmanlık alanı silinirken bir hata oluştu.",
          "expertiseLoadError": "Uzmanlık alanları yüklenirken bir hata oluştu.",
          "expertiseMoveError": "Uzmanlık alanı taşınırken bir hata oluştu.",
          "portfolioCategories": "Portföy Kategorileri",
          "addNewCategory": "Yeni Kategori Ekle",
          "editCategory": "Kategori Düzenle",
          "categoryTitle": "Kategori Başlığı",
          "categoryTitlePlaceholder": "Kategori başlığı girin",
          "categoryUpdated": "Kategori başarıyla güncellendi",
          "categoryDeleted": "Kategori başarıyla silindi",
          "portfolioProjects": "Portföy Projeleri",
          "newProject": "Yeni Proje",
          "editProject": "Proje Düzenle",
          "projectTitle": "Proje Başlığı",
          "projectTitlePlaceholder": "Proje başlığı girin",
          "projectDescription": "Proje Açıklaması",
          "projectDescriptionPlaceholder": "Proje açıklaması girin",
          "projectCategory": "Proje Kategorisi",
          "projectStatus": "Proje Durumu",
          "projectStatusDraft": "Taslak",
          "projectStatusPublished": "Yayınlandı",
          "projectImages": "Proje Görselleri",
          "projectImagesPlaceholder": "En fazla 25 görsel yükleyebilirsiniz",
          "projectCreated": "Proje başarıyla oluşturuldu",
          "projectUpdated": "Proje başarıyla güncellendi",
          "projectDeleted": "Proje başarıyla silindi",
          "projectError": "Proje işlemi sırasında bir hata oluştu",
          "delete": "Sil",
          "loading": "Yükleniyor...",
          "dropImagesHere": "Görselleri buraya bırakın",
          "dragAndDropImages": "Görselleri sürükleyip bırakın veya seçin",
          "selectImages": "Görsel Seç",
          "dragAndDropVideos": "Videoları sürükleyip bırakın veya seçin",
          "selectVideos": "Video Seç",
          "dropVideosHere": "Videoları buraya bırakın",
          "imageDeleted": "Görsel başarıyla silindi",
          "imageDeleteError": "Görsel silinirken bir hata oluştu",
          "actions": "İşlemler"
        }
      },
      en: {
        translation: {
          "newCategory": "Add New Category",
          "categoryName": "Category Name",
          "description": "Description",
          "icon": "Icon",
          "categoryImage": "Category Image",
          "save": "Save",
          "cancel": "Cancel",
          "saving": "Saving...",
          "error": "Error",
          "success": "Success",
          "pleaseSelectImage": "Please select an image.",
          "categoryCreated": "Category created successfully.",
          "categoryError": "Failed to save category. Please try again.",
          "noCategories": "No categories found.",
          "expertiseAreas": "Our Expertise Areas",
          "newExpertiseArea": "New Expertise Area",
          "editExpertiseArea": "Edit Expertise Area",
          "expertiseTitle": "Title",
          "expertiseDescription": "Description",
          "expertiseIcon": "Icon",
          "expertiseIconPlaceholder": "Search icon...",
          "expertiseTitlePlaceholder": "Expertise area title",
          "expertiseDescriptionPlaceholder": "Expertise area description",
          "expertiseSelected": "Selected:",
          "expertiseNoResults": "No results",
          "expertiseLoading": "Loading...",
          "expertiseSaving": "Saving...",
          "expertiseSave": "Save",
          "expertiseCancel": "Cancel",
          "expertiseSuccess": "Success",
          "expertiseError": "Error",
          "expertiseCreated": "Expertise area created successfully.",
          "expertiseUpdated": "Expertise area updated successfully.",
          "expertiseDeleted": "Expertise area deleted successfully.",
          "expertiseCreateError": "Error creating expertise area.",
          "expertiseUpdateError": "Error updating expertise area.",
          "expertiseDeleteError": "Error deleting expertise area.",
          "expertiseLoadError": "Error loading expertise areas.",
          "expertiseMoveError": "Error moving expertise area.",
          "portfolioCategories": "Portfolio Categories",
          "addNewCategory": "Add New Category",
          "editCategory": "Edit Category",
          "categoryTitle": "Category Title",
          "categoryTitlePlaceholder": "Enter category title",
          "categoryUpdated": "Category updated successfully",
          "categoryDeleted": "Category deleted successfully",
          "portfolioProjects": "Portfolio Projects",
          "newProject": "New Project",
          "editProject": "Edit Project",
          "projectTitle": "Project Title",
          "projectTitlePlaceholder": "Enter project title",
          "projectDescription": "Project Description",
          "projectDescriptionPlaceholder": "Enter project description",
          "projectCategory": "Project Category",
          "projectStatus": "Project Status",
          "projectStatusDraft": "Draft",
          "projectStatusPublished": "Published",
          "projectImages": "Project Images",
          "projectImagesPlaceholder": "You can upload up to 15 images",
          "projectCreated": "Project created successfully",
          "projectUpdated": "Project updated successfully",
          "projectDeleted": "Project deleted successfully",
          "projectError": "An error occurred while processing the project",
          "delete": "Delete",
          "loading": "Loading...",
          "dropImagesHere": "Drop images here",
          "dragAndDropImages": "Drag and drop images or click to select",
          "selectImages": "Select Images",
          "dragAndDropVideos": "Drag and drop videos or click to select",
          "selectVideos": "Select Videos",
          "dropVideosHere": "Drop videos here",
          "imageDeleted": "Image deleted successfully",
          "imageDeleteError": "Error deleting image"
        }
      },
      ar: {
        translation: {
          "newCategory": "إضافة فئة جديدة",
          "categoryName": "اسم الفئة",
          "description": "الوصف",
          "icon": "الأيقونة",
          "categoryImage": "صورة الفئة",
          "save": "حفظ",
          "cancel": "إلغاء",
          "saving": "جاري الحفظ...",
          "error": "خطأ",
          "success": "نجاح",
          "pleaseSelectImage": "الرجاء اختيار صورة.",
          "categoryCreated": "تم إنشاء الفئة بنجاح.",
          "categoryError": "فشل في حفظ الفئة. يرجى المحاولة مرة أخرى.",
          "noCategories": "لا توجد فئات.",
          "expertiseAreas": "مجالات خبرتنا",
          "newExpertiseArea": "إضافة مجال خبرة جديد",
          "editExpertiseArea": "تعديل مجال الخبرة",
          "expertiseTitle": "العنوان",
          "expertiseDescription": "الوصف",
          "expertiseIcon": "الأيقونة",
          "expertiseIconPlaceholder": "البحث عن أيقونة...",
          "expertiseTitlePlaceholder": "عنوان مجال الخبرة",
          "expertiseDescriptionPlaceholder": "وصف مجال الخبرة",
          "expertiseSelected": "المحدد:",
          "expertiseNoResults": "لا توجد نتائج",
          "expertiseLoading": "جاري التحميل...",
          "expertiseSaving": "جاري الحفظ...",
          "expertiseSave": "حفظ",
          "expertiseCancel": "إلغاء",
          "expertiseSuccess": "نجاح",
          "expertiseError": "خطأ",
          "expertiseCreated": "تم إضافة مجال الخبرة بنجاح.",
          "expertiseUpdated": "تم تحديث مجال الخبرة بنجاح.",
          "expertiseDeleted": "تم حذف مجال الخبرة بنجاح.",
          "expertiseCreateError": "خطأ في إضافة مجال الخبرة.",
          "expertiseUpdateError": "خطأ في تحديث مجال الخبرة.",
          "expertiseDeleteError": "خطأ في حذف مجال الخبرة.",
          "expertiseLoadError": "خطأ في تحميل مجالات الخبرة.",
          "expertiseMoveError": "خطأ في نقل مجال الخبرة.",
          "portfolioCategories": "فئات المحفظة",
          "addNewCategory": "إضافة فئة جديدة",
          "editCategory": "تعديل الفئة",
          "categoryTitle": "عنوان الفئة",
          "categoryTitlePlaceholder": "أدخل عنوان الفئة",
          "categoryUpdated": "تم تحديث الفئة بنجاح",
          "categoryDeleted": "تم حذف الفئة بنجاح",
          "portfolioProjects": "مشاريع المحفظة",
          "newProject": "مشروع جديد",
          "editProject": "تعديل المشروع",
          "projectTitle": "عنوان المشروع",
          "projectTitlePlaceholder": "أدخل عنوان المشروع",
          "projectDescription": "وصف المشروع",
          "projectDescriptionPlaceholder": "أدخل وصف المشروع",
          "projectCategory": "فئة المشروع",
          "projectStatus": "حالة المشروع",
          "projectStatusDraft": "مسودة",
          "projectStatusPublished": "منشور",
          "projectImages": "صور المشروع",
          "projectImagesPlaceholder": "يمكنك تحميل ما يصل إلى 15 صورة",
          "projectCreated": "تم إنشاء المشروع بنجاح",
          "projectUpdated": "تم تحديث المشروع بنجاح",
          "projectDeleted": "تم حذف المشروع بنجاح",
          "projectError": "حدث خطأ أثناء معالجة المشروع",
          "delete": "حذف",
          "loading": "جار التحميل...",
          "dropImagesHere": "إفلات الصور هنا",
          "dragAndDropImages": "اسحب وأفلت الصور أو انقر للاختيار",
          "selectImages": "اختر الصور",
          "dragAndDropVideos": "اسحب وأفلت مقاطع الفيديو أو انقر للتحديد",
          "selectVideos": "اختر الفيديو",
          "dropVideosHere": "إسقاط مقاطع الفيديو هنا",
          "imageDeleted": "تم حذف الصورة بنجاح",
          "imageDeleteError": "خطأ في حذف الصورة"
        }
      }
    },
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n; 